<template>
    <div>
        <div v-if="isShow">
            <!-- 学员页面筛选 -->
            <div v-if="tableName === 'student'">
                <el-form :model="studentForm" label-width="150px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="姓名：">
                                <input v-model="studentForm.uname" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="准考证号：">
                                <input v-model="studentForm.admissionCard" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="手机号：">
                                <input v-model="studentForm.phone" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="批次号/班级编码：">
                                <input v-model="studentForm.classCode" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="合作院校：">
                                <el-select
                                    v-model="studentForm.schoolId"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in schoolList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="合作机构：">
                                <el-select
                                    v-model="studentForm.companyId"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in companyList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!-- 考勤页面筛选 -->
            <div v-else-if="tableName === 'attendance'">
                <el-form :model="studentForm" label-width="150px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="姓名：">
                                <input v-model="attendanceForm.uname" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="签到状态：">
                                <input
                                    placeholder="签到成功或者未签到"
                                    v-model="attendanceForm.signStatus"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="签退状态：">
                                <input
                                    placeholder="签退成功或者未签退"
                                    v-model="attendanceForm.singOutStatus"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="批次号/班级编码：">
                                <input v-model="attendanceForm.classCode" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="9">
                            <el-form-item label="签到时间：">
                                <el-time-picker
                                    size="small"
                                    is-range
                                    v-model="signOpenTime"
                                    range-separator="至"
                                    start-placeholder="签到起始时间"
                                    end-placeholder="签到结束时间"
                                    placeholder="选择时间范围"
                                >
                                </el-time-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="9">
                            <el-form-item label="签退时间：">
                                <el-time-picker
                                    size="small"
                                    is-range
                                    v-model="signEndTime"
                                    range-separator="至"
                                    start-placeholder="签退起始时间"
                                    end-placeholder="签退结束时间"
                                    placeholder="选择时间范围"
                                >
                                </el-time-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!-- 课时管理页面筛选 -->
            <div v-else-if="tableName === 'classTime'">
                <el-form :model="studentForm" label-width="150px">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="课程名称：">
                                <input v-model="classTimeForm.name" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="课时：">
                                <input v-model="classTimeForm.tiem" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="批次号/班级编码：">
                                <input v-model="classTimeForm.classCode" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="开始时间：">
                                <el-time-picker
                                    size="small"
                                    is-range
                                    v-model="signOpenTime"
                                    range-separator="至"
                                    start-placeholder="签到起始时间"
                                    end-placeholder="签到结束时间"
                                    placeholder="选择时间范围"
                                >
                                </el-time-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="结束时间：">
                                <el-time-picker
                                    size="small"
                                    is-range
                                    v-model="signEndTime"
                                    range-separator="至"
                                    start-placeholder="签退起始时间"
                                    end-placeholder="签退结束时间"
                                    placeholder="选择时间范围"
                                >
                                </el-time-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="状态：">
                                <el-select
                                    v-model="classTimeForm.status"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        key="a开课中"
                                        label="a开课中"
                                        value="a开课中"
                                    >
                                    </el-option>
                                    <el-option
                                        key="b未开课"
                                        label="b未开课"
                                        value="b未开课"
                                    >
                                    </el-option>
                                    <el-option
                                        key="c已结课"
                                        label="c已结课"
                                        value="c已结课"
                                    >
                                    </el-option>
                                    <el-option
                                        key="d已取消"
                                        label="d已取消"
                                        value="d已取消"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="合作院校：">
                                <el-select
                                    v-model="classTimeForm.schoolId"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in schoolList"
                                        :key="item.id"
                                        :label="item.title"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="合作机构：">
                                <el-select
                                    v-model="classTimeForm.companyId"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in companyList"
                                        :key="item.id"
                                        :label="item.title"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div v-else>
                <el-form :model="studentForm" label-width="150px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="课程名称：">
                                <input v-model="classForm.title" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="讲师名称：">
                                <input v-model="classForm.teacher" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="报名方式：">
                                <el-select
                                    v-model="classForm.apply_type"
                                    placeholder="请选择报名方式"
                                    size="mini"
                                >
                                    <el-option
                                        label="先审核后缴费"
                                        :value="0"
                                    ></el-option>
                                    <el-option
                                        label="先缴费后审核"
                                        :value="1"
                                    ></el-option>
                                    <el-option
                                        label="仅审核无缴费"
                                        :value="2"
                                    ></el-option>
                                    <el-option
                                        label="无审核仅缴费"
                                        :value="3"
                                    ></el-option>
                                    <el-option
                                        label="无审核无缴费"
                                        :value="4"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="建课学校：">
                                <el-select
                                    v-model="classForm.mhm_id"
                                    placeholder="请选择"
                                    size="mini"
                                >
                                    <el-option
                                        v-for="item in schoolList"
                                        :key="item.id"
                                        :label="item.title"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!-- 确认按钮  -->
            <div class="btn">
                <button
                    style="background-color: #409eff; border: 0; color: #fff;cursor: pointer"
                    @click="okFn"
                >
                    确认
                </button>
                <button @click="$emit('update:isShow', false)" style="cursor: pointer">收起</button>
                <button @click="clearFn" style="cursor: pointer">清空</button>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getStudentList,
    getSignList,
    getListByCategory,
    getbatchList,
} from "@/api/LiveLesson/classTimeapi.js";

import { selectTableList, getSchoolList } from "@/api/LiveLesson/index.js";
export default {
    data() {
        return {
            // 建课学校
            schoolList: [],
            // 合作院校
            companyList: [],
            studentForm: {
                uname: "",
                admissionCard: "",
                admissionCard: "",
                admissionCard: "",
                schoolId: "",
                companyId: "",
            },
            attendanceForm: {
                uname: "",
                signStatus: "",
                singOutStatus: "",
                classCode: "",
                signOpenTimeMin: "",
                signOpenTimeMax: "",
                signEndTimeMin: "",
                signEndTimeMax: "",
            },
            classTimeForm: {
                name: "",
                tiem: "",
                classCode: "",
                status: "",
                schoolId: "",
                companyId: "",
                signOpenTimeMin: "",
                signOpenTimeMax: "",
                signEndTimeMin: "",
                signEndTimeMax: "",
            },
            classForm: {
                title: "",
                teacher: "",
                apply_type: "",
                mhm_id: "",
            },
            signOpenTime: "",
            signEndTime: "",
        };
    },
    methods: {
        async init() {
            if (this.tableName === "") {
                let schoolList = await getSchoolList();
                this.schoolList = schoolList.data.data || [];
                console.log(schoolList);
                return;
            }
            // 机构列表
            const company = await getListByCategory({ schoolCategory: 28 });
            this.companyList = company.data.data;
            // 学校列表
            const school = await getListByCategory({ schoolCategory: 27 });
            this.schoolList = school.data.data;
        },
        async okFn() {
            if (this.tableName === "student") {
                const res = await getStudentList(this.studentForm);
                this.$emit("selectFn", res.data.data.list);
                this.clearFn();
            } else if (this.tableName === "attendance") {
                const res = await getSignList(this.attendanceForm);
                this.$emit("selectFn", res.data.data.list);
                this.clearFn();
            } else if (this.tableName === "classTime") {
                const res = await getbatchList({
                    courseId: this.courseId,
                    ...this.classTimeForm,
                });
                this.$emit("selectFn", res.data.data.list);
                this.clearFn();
            } else {
                let res = await selectTableList(this.classForm);
                res = JSON.parse(JSON.stringify(res));
                this.$emit("selectFn", res.data.data.data);
                this.clearFn();
            }
        },
        async clearFn() {
            if (this.tableName === "student") {
                this.studentForm = {
                    uname: "",
                    admissionCard: "",
                    admissionCard: "",
                    admissionCard: "",
                    schoolId: "",
                    companyId: "",
                };
            } else if (this.tableName === "attendance") {
                this.attendanceForm = {
                    uname: "",
                    signStatus: "",
                    singOutStatus: "",
                    classCode: "",
                    signOpenTimeMin: "",
                    signOpenTimeMax: "",
                    signEndTimeMin: "",
                    signEndTimeMax: "",
                };
            } else if (this.tableName === "classTime") {
                this.classTimeForm = {
                    name: "",
                    tiem: "",
                    classCode: "",
                    status: "",
                    schoolId: "",
                    companyId: "",
                    signOpenTimeMin: "",
                    signOpenTimeMax: "",
                    signEndTimeMin: "",
                    signEndTimeMax: "",
                };
            } else {
                this.classForm = {
                    title: "",
                    teacher: "",
                    apply_type: "",
                    mhm_id: "",
                };
            }
            this.signOpenTime = "";
            this.signEndTime = "";
        },
    },
    created() {
        this.init();
    },
    props: {
        isShow: {
            type: Boolean,
            default: true,
        },
        tableName: {
            type: String,
        },
        courseId: {
            type: String,
        },
    },
    watch: {
        signOpenTime: function () {
            if (this.tableName === "attendance") {
                this.attendanceForm.signOpenTimeMin = this.signOpenTime[0];
                this.attendanceForm.signOpenTimeMax = this.signOpenTime[1];
            }
            if (this.tableName === "classTime") {
                this.classTimeForm.signOpenTimeMin = this.signOpenTime[0];
                this.classTimeForm.signOpenTimeMax = this.signOpenTime[1];
            }
        },
        signEndTime: function () {
            if (this.tableName === "attendance") {
                this.attendanceForm.signEndTimeMin = this.signEndTime[0];
                this.attendanceForm.signEndTimeMax = this.signEndTime[1];
            }
            if (this.tableName === "classTime") {
                this.classTimeForm.signEndTimeMin = this.signEndTime[0];
                this.classTimeForm.signEndTimeMax = this.signEndTime[1];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
input {
    display: inline-block;
    width: 206px;
    height: 32px;
    border: 1px solid #c0c4cc;
    border-radius: 5px;
}
.el-row {
    font-size: 16px;
}
.btn {
    text-align: center;
}
button {
    width: 73px;
    height: 28px;
    border: 1px solid #000;
    border-radius: 5px;
    margin: 0 20px;
}
</style>